import { Field } from 'formik';
import React from 'react';
import StyledErrorMessage from './formik/input/StyledErrorMessage';

interface AuthFormFieldProps {
  name: string;
  type?: string;
  text?: string;
  placeholder?: string;
}

const AuthFormField = ({ name, type, text, placeholder }: AuthFormFieldProps) => {
  return (
    <div className='flex flex-col gap-4 my-4'>
      <label htmlFor={name} className='text-deepspace font-semibold text-4xl text-center'>
        {text ?? name.toUpperCase()}
      </label>
      <Field
        name={name}
        className='w-auto lg:w-1/2 h-12 p-4 mx-auto'
        placeholder={placeholder ?? name.charAt(0).toUpperCase() + name.slice(1)}
        type={type ?? ''}
      ></Field>
      <StyledErrorMessage name={name} className='text-center'></StyledErrorMessage>
    </div>
  );
};

export default AuthFormField;
